import { Link } from 'react-router-dom';

const footerLinks = {
  navigation: [
    { name: '首页', path: '/' },
    { name: '网红塌房', path: '/category/wanghong-tafang' },
    { name: '明星八卦', path: '/category/mingxing-bagua' },
    { name: '独家爆料', path: '/category/dujia-baoliao' },
    { name: '社会热点', path: '/category/shehui-redian' },
    { name: '关于我们', path: '/about' },
  ],
  categories: [
    { name: '综艺节目', path: '/category/zongyi-jiemu' },
    { name: '直播翻车', path: '/category/zhibo-fanche' },
    { name: '51吃瓜在线', path: '/' },
    { name: '51黑料在线观看', path: '/' },
    { name: '黑料网在线观看', path: '/' },
    { name: '吃瓜黑料在线app', path: '/' },
  ],
} as const;

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-fire-line text-xl" style={{ color: 'oklch(0.68 0.17 82)' }}></i>
              </div>
              <span className="font-heading text-lg font-bold text-background-50">
                吃瓜黑料在线
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed max-w-xs">
              吃瓜黑料在线网站——最全面的网红塌房、明星八卦、独家爆料聚合平台。实时更新，让你不错过任何一个瓜。
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              <a href="/" className="hover:text-accent-400 transition-colors">快速导航</a>
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.navigation.map((link) => (
                <li key={link.path + link.name}>
                  <Link
                    to={link.path}
                    className="text-sm text-background-400 hover:text-accent-400 transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              <a href="/" className="hover:text-accent-400 transition-colors">热门标签</a>
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.categories.map((link) => (
                <li key={link.path + link.name}>
                  <Link
                    to={link.path}
                    className="text-sm text-background-400 hover:text-accent-400 transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              <a href="/about" className="hover:text-accent-400 transition-colors">联系我们</a>
            </h4>
            <ul className="space-y-2.5 text-sm text-background-400">
              <li className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-mail-line"></i>
                </div>
                <span>contact@chiguaheiliaozx.com</span>
              </li>
              <li className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-shield-check-line"></i>
                </div>
                <span>内容投稿与合作</span>
              </li>
              <li className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-error-warning-line"></i>
                </div>
                <span>侵权投诉与反馈</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-background-800">
        <div className="w-full px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2026 吃瓜黑料在线 chiguaheiliaozx.com 版权所有
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <a href="/about" className="hover:text-background-300 transition-colors">关于我们</a>
            <span className="text-background-700">|</span>
            <a href="/about" className="hover:text-background-300 transition-colors">免责声明</a>
            <span className="text-background-700">|</span>
            <a href="/about" className="hover:text-background-300 transition-colors">隐私政策</a>
          </div>
        </div>
      </div>
    </footer>
  );
}